import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.STRINGS)({
    component: StringsLayout,
    staticData: {
        config: {
            breadcrumb: { title: "strings", to: APP_ROUTES_TO.STRINGS },
            title: "strings",
        },
        permissions: [PERMISSIONS.APP_STRINGS_LIST],
    },
});

function StringsLayout() {
    return <Outlet />;
}
